require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconChevronUp.tsx
var IconChevronUp_exports = {};
__export(IconChevronUp_exports, {
  default: () => IconChevronUp_default
});
module.exports = __toCommonJS(IconChevronUp_exports);

// src/assets/monochrome/chevronUp.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgChevronUp = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9353 13.3736C14.0462 13.4854 14.1781 13.5741 14.3234 13.6347C14.4688 13.6952 14.6246 13.7264 14.7821 13.7264C14.9395 13.7264 15.0954 13.6952 15.2408 13.6347C15.3861 13.5741 15.518 13.4854 15.6289 13.3736C15.8511 13.1501 15.9757 12.8479 15.9757 12.5328C15.9757 12.2177 15.8511 11.9154 15.6289 11.692L10.56 6.62322C10.3366 6.40109 10.0343 6.2764 9.71919 6.2764C9.40411 6.2764 9.10184 6.40109 8.87837 6.62322L3.82141 11.692C3.59927 11.9154 3.47461 12.2177 3.47461 12.5328C3.47461 12.8479 3.59927 13.1501 3.82141 13.3736C4.04487 13.5957 4.34717 13.7204 4.66226 13.7204C4.97735 13.7204 5.27962 13.5957 5.50308 13.3736L9.72516 9.15163L13.9353 13.3736Z", fill: "#818898" }) });
var chevronUp_default = SvgChevronUp;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconChevronUp.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconChevronUp = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(chevronUp_default, {}) });
};
IconChevronUp.displayName = "IconChevronUp";
var IconChevronUp_default = IconChevronUp;
